(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($translateProvider, $urlRouterProvider, $stateProvider) {
    $stateProvider
      .state('home', {
          url: "/home",
          templateUrl: "module/core/home.html"
      })
    ;
  }

})();
